// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/mail.js';

import { paths } from '../generated/mail';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('mail', Original, paths);
